export function preventSyntheticEvent(e) {
    e.preventDefault();
    e.stopPropagation();
    return false;
}
export function px(px) {
    return `${px}px`;
}
export function percent(percent) {
    return `${percent}%`;
}
export function getMetaDesc() {
    const metas = document.getElementsByTagName('meta');
    const meta = Array.from(metas).find(i => i.name.toLowerCase() === 'description');
    if (meta) {
        return meta.content;
    }
    return '';
}
// 跳转至页面底部
export function jumpToBottom(element, bottomIndex = 10000) {
    element &&
        element.scrollTo({
            top: bottomIndex,
            behavior: 'smooth',
        });
}
/**
 * 合并两个css class样式
 * @param  styleOne
 * @param  styleTwo
 * @returns
 */
export function mergeCssStyles(styleOne, styleTwo) {
    var _a, _b;
    const resultStyle = {};
    for (const key of [...Object.keys(styleOne), ...Object.keys(styleTwo)]) {
        resultStyle[key] = `${(_a = styleOne[key]) !== null && _a !== void 0 ? _a : ''} ${(_b = styleTwo[key]) !== null && _b !== void 0 ? _b : ''}`;
    }
    return resultStyle;
}
